var PERMIT2_DOMAIN_NAME = 'Permit2';
export function permit2Domain(permit2Address, chainId) {
    return {
        name: PERMIT2_DOMAIN_NAME,
        chainId: chainId,
        verifyingContract: permit2Address,
    };
}
